import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderSeasonsInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderSeasonsGql } from '../../workOrderQueries';

const requestId = 'uerUpdateWorkOrderSeasons';

export const useUerUpdateWorkOrderSeasons = (workOrderId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerUpdateWorkOrderSeasonsReset] = useResetStoreData({ requestId });

    const [, uerUpdateWorkOrderSeasonsStatus, , uerUpdateWorkOrderSeasonsRequest] = useRequest({
        requestId,
        query: uerUpdateWorkOrderSeasonsGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const uerUpdateWorkOrderSeasonsMakeRequest = useCallback(
        (input: WorkOrderSeasonsInput) => {
            dispatch(uerUpdateWorkOrderSeasonsRequest({ workOrderId, input }));
        },
        [uerUpdateWorkOrderSeasonsRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        uerUpdateWorkOrderSeasonsReset(undefined);
    }, [uerUpdateWorkOrderSeasonsReset]);

    return {
        uerUpdateWorkOrderSeasonsStatus,
        uerUpdateWorkOrderSeasonsMakeRequest,
    };
};
